import { styled } from '@mui/system';
import { theme } from './theme';

export const Wrapper = styled('div')({
    height: "calc(100vh - 105px)",
    display: "flex",
    flexDirection: "column",
    width:"100%",
});

export const commonStyle = {
    calendarStyle : {
        "&.noPastErrorStyle .Mui-error":{
          color:theme.palette.text.primary,
        },
        "&.noPastErrorStyle .Mui-error.MuiFormHelperText-root ":{
          color:theme.palette.error.main,
        },
        "& .MuiButtonBase-root ": {
          "& svg": {
            height: "18px",
            width: "18px",
            color: "#A8A8A8",
          },
        },
      }
}

